// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_4k4","cls2":"PremiumBadge-cls2_o84 PremiumBadge-cls1_4k4"};